import { PrimaryDefaultButton } from '@/components/buttons/primary';
import { Container } from '@/components/layout/Container';
import { LegalDocumentFragment } from '@/graphql';
import { marginY, mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

const Heading = styled.h1`
  text-align: center;
  ${customTextSize(48, 54)};
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-bottom: ${remCalc(40)};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(72, 78)};
  }
`;

const DocumentWrapper = styled.div`
  text-align: center;

  iframe {
    margin: 0 auto;
    width: 100%;
    height: ${remCalc(600)};
  }

  p {
    ${marginY(40)}
    ${customTextSize(18, 26)};
  }

  ${PrimaryDefaultButton} {
    display: inline-block;
    margin: 0 auto;
  }
`;

interface LegalDocumentPageProps {
  entry: LegalDocumentFragment;
}

const LegalDocumentPage: PageTemplate<LegalDocumentPageProps> = ({ entry }) => {
  return (
    <Container>
      <article>
        <Heading>{entry?.title}</Heading>

        {entry?.legalPdfAssets?.map((asset) => (
          <DocumentWrapper key={asset?.id}>
            <iframe src={`//docs.google.com/viewer?url=${encodeURIComponent(asset?.url!)}&embedded=true`} />

            <p>Having trouble viewing the document?</p>

            <PrimaryDefaultButton as="a" target="_blank" href={asset?.url!}>
              Download PDF
            </PrimaryDefaultButton>
          </DocumentWrapper>
        ))}
      </article>
    </Container>
  );
};

export default LegalDocumentPage;
